module.exports = __webpack_public_path__ + "static/img/codex_large.f91e4f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/img/codex_large.png
// module id = 4sz1
// module chunks = 0